"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 border border-[var(--border)] bg-[var(--card)] backdrop-blur-md rounded-md">
        <p className="font-mono text-xs uppercase tracking-widest text-[var(--primary)] mb-4">— COMUNICACIÓN RECIBIDA</p>
        <p className="font-default text-xl text-foreground mb-6">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="border-[var(--border)] rounded-md font-mono text-xs">
          ENVIAR OTRO MENSAJE
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-8">
      <FormField control={control} name="name" rules={{
      required: "El nombre es obligatorio",
      minLength: {
        value: 2,
        message: "Mínimo 2 caracteres"
      }
    }} render={({
      field
    }) => <FormItem className="gap-1">
            <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">— NOMBRE COMPLETO</FormLabel>
            <FormControl>
              <Input {...field} placeholder="Ingrese su nombre y apellidos" className="border-0 border-b-2 border-[var(--border)] bg-transparent px-0 h-12 font-default text-lg focus-visible:ring-0 focus-visible:border-[var(--primary)] transition-colors rounded-md" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "El correo es obligatorio",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Email inválido"
      }
    }} render={({
      field
    }) => <FormItem className="gap-1">
            <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">— CORREO ELECTRÓNICO</FormLabel>
            <FormControl>
              <Input {...field} type="email" placeholder="contacto@empresa.com" className="border-0 border-b-2 border-[var(--border)] bg-transparent px-0 h-12 font-default text-lg focus-visible:ring-0 focus-visible:border-[var(--primary)] transition-colors rounded-md" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="phone" rules={{
      pattern: {
        value: /^[+\d\s()-]{7,}$/,
        message: "Teléfono inválido"
      }
    }} render={({
      field
    }) => <FormItem className="gap-1">
            <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">— TELÉFONO DE CONTACTO</FormLabel>
            <FormControl>
              <Input {...field} type="tel" placeholder="+52 (55) 0000-0000" className="border-0 border-b-2 border-[var(--border)] bg-transparent px-0 h-12 font-default text-lg focus-visible:ring-0 focus-visible:border-[var(--primary)] transition-colors rounded-md" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="subject" render={({
      field
    }) => <FormItem className="gap-1">
            <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">— SERVICIO DE INTERÉS</FormLabel>
            <FormControl>
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger className="border-0 border-b-2 border-[var(--border)] bg-transparent px-0 h-12 font-default text-lg focus-visible:ring-0 focus-visible:border-[var(--primary)] w-full rounded-md">
                  <SelectValue placeholder="Seleccione un servicio" />
                </SelectTrigger>
                <SelectContent className="border-[var(--border)] bg-[var(--popover)] font-mono text-xs uppercase tracking-widest rounded-md">
                  <SelectItem value="guardias" className="">SEGURIDAD FÍSICA</SelectItem>
                  <SelectItem value="monitoreo" className="">MONITOREO C4</SelectItem>
                  <SelectItem value="gps" className="">RASTREO GPS</SelectItem>
                  <SelectItem value="consultoria" className="">CONSULTORÍA</SelectItem>
                </SelectContent>
              </Select>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "El mensaje es obligatorio",
      minLength: {
        value: 10,
        message: "Mínimo 10 caracteres"
      }
    }} render={({
      field
    }) => <FormItem className="gap-1">
            <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">— REQUERIMIENTOS ESPECÍFICOS</FormLabel>
            <FormControl>
              <Textarea {...field} placeholder="Describa sus necesidades de protección..." rows={5} className="border-0 border-b-2 border-[var(--border)] bg-transparent px-0 font-default text-lg focus-visible:ring-0 focus-visible:border-[var(--primary)] transition-colors resize-none rounded-md" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 border border-[var(--destructive)] bg-[var(--destructive)]/10 rounded-md">
          <p className="text-[var(--destructive)] font-mono text-xs uppercase tracking-widest">{submitError}</p>
        </div>}

      <div className="pt-4 space-y-6">
        <div className="flex items-center gap-3">
          <span className="relative flex size-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-md bg-[var(--primary)] opacity-75"></span>
            <span className="relative inline-flex size-2 rounded-md bg-[var(--primary)]"></span>
          </span>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            RESPUESTA OPERATIVA — EN MENOS DE 24 HORAS
          </p>
        </div>

        <Button type="submit" disabled={isSubmitting} className="w-full rounded-md h-14 bg-[var(--primary)] text-[var(--primary-foreground)] hover:bg-[var(--primary)]/90 font-mono text-sm uppercase tracking-[0.2em] shadow-xl transition-all hover:translate-x-1">
          {isSubmitting ? "PROCESANDO..." : "SOLICITAR PROTECCIÓN →"}
        </Button>
      </div>
    </Form>;
}
export default function InicieSuProtecciN() {
  const contactMethods = [{
    label: "CORREO",
    value: "contacto@grupoposeidon.com.mx",
    to: "mailto:contacto@grupoposeidon.com.mx"
  }, {
    label: "CENTRAL",
    value: "+52 (55) 1234-5678",
    to: "tel:+525512345678"
  }, {
    label: "VENTAS",
    value: "comercial@grupoposeidon.com.mx",
    to: "mailto:comercial@grupoposeidon.com.mx"
  }];
  return <section data-section-id="4321" id="inicie-su-protección" className="bg-background text-foreground relative overflow-hidden py-20 lg:py-28 px-6 lg:px-12 min-h-screen flex items-center">
      {}
      <div className="absolute top-1/4 -left-40 size-96 rounded-md bg-[var(--primary)] opacity-5 blur-[120px] pointer-events-none" />
      <div className="absolute bottom-1/4 -right-40 size-96 rounded-md bg-[var(--primary)] opacity-5 blur-[120px] pointer-events-none" />

      <div className="relative w-full max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-[45fr_55fr] gap-12 lg:gap-16 items-start">
        {}
        <div className="space-y-10 lg:sticky lg:top-24">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[var(--primary)]">
            — CONTACTO ESTRATÉGICO
          </p>

          <h2 className="font-default font-bold uppercase leading-[0.85] tracking-tighter text-foreground text-[clamp(3.5rem,11vw,10rem)]">
            <span className="font-light">INICIE</span>
            <br />
            PROTECCIÓN.
          </h2>

          <p className="font-default text-lg lg:text-[19px] leading-relaxed text-muted-foreground max-w-[480px]">
            Para consultoría de riesgos, servicios de guardia intramuros o soluciones tecnológicas de vigilancia, nuestro equipo de expertos está listo para responder.
          </p>

          <div className="pt-6 border-t border-[var(--border)] space-y-1">
            {contactMethods.map((method, i) => <Link key={i} data-index={i} to={method.to} className="group flex items-center justify-between gap-4 py-5 border-b border-[var(--border)] hover:bg-[var(--accent)] transition-colors px-2 -mx-2">
                <div className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-6 min-w-0">
                  <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground shrink-0">
                    — {method.label}
                  </span>
                  <span className="font-default text-base sm:text-lg text-foreground truncate">
                    {method.value}
                  </span>
                </div>
                <ArrowUpRight className="size-5 text-[var(--primary)] shrink-0 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.5} />
              </Link>)}
          </div>
        </div>

        {}
        <FormProvider formKey="start_protection_form_home" formId="start_protection_form_home" sectionName="inicie-su-protección" defaultValues={{
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
      }} validationRules={{
        name: {
          required: true,
          minLength: 2
        },
        email: {
          required: true,
          pattern: "email"
        },
        phone: {
          pattern: "phone"
        },
        message: {
          required: true,
          minLength: 10
        }
      }} submitText="Solicitar Protección" successMessage="Su solicitud ha sido recibida. Un consultor de seguridad de POSEIDÓN se pondrá en contacto con usted en breve." errorMessage="Ocurrió un error. Por favor intente de nuevo o llame a nuestra central operativa." className="relative">
          <div className="relative border border-[var(--border)] bg-[var(--card)] backdrop-blur-md p-8 sm:p-12 lg:p-14 shadow-4xl rounded-md">
            {}
            <div className="absolute inset-0 bg-gradient-to-br from-foreground/[0.02] to-transparent pointer-events-none" />

            <div className="relative">
              <div className="mb-10 pb-6 border-b border-[var(--border)]">
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--primary)] mb-3">
                  — MENSAJE DIRECTO
                </p>
                <h3 className="font-default text-2xl sm:text-3xl font-bold uppercase tracking-tight text-foreground">
                  Conecte con POSEIDÓN
                </h3>
              </div>

              <ContactForm />
            </div>
          </div>
        </FormProvider>
      </div>
    </section>;
}